import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { api } from "../lib/api";

const ago = (iso) => {
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  return m < 60 ? `${m} min ago` : `${Math.round(m / 60)} h ago`;
};

export const HotLeads = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    const load = () => api.get("/sales/hot-leads").then((r) => setItems(r.data)).catch(() => setItems([]));
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  if (!items) return null;
  return (
    <div className="ax-panel p-4 mb-6" data-testid="hot-leads">
      <div className="flex items-center gap-2 mb-2"><Flame className="h-4 w-4 text-primary" /><span className="ax-label">Hot right now · opened a file in the last 48 hours</span>
        <span className="num text-xs text-muted-foreground" data-testid="hot-leads-count">{items.length}</span></div>
      {!items.length ? <p className="text-sm text-muted-foreground" data-testid="hot-leads-empty">No one has opened a shared file in the last 48 hours.</p> : (
        <div className="divide-y divide-border/50">
          {items.map((l) => (
            <Link key={l.lead_id} to={`/sales/leads/${l.lead_id}`} data-testid={`hot-lead-${l.lead_id}`} className="flex flex-wrap items-center gap-x-3 gap-y-1 py-2 text-sm hover:text-primary">
              <span className="font-medium">{l.company_name || l.contact_name}</span>
              <span className="text-muted-foreground text-xs">{l.contact_name} · {l.owner || "—"}</span>
              <span className="text-xs">opened "{l.last_file_open.file}"</span>
              <span className="ml-auto text-xs text-primary num">{ago(l.last_file_open.at)}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};
